import React from 'react'

export default function Partner() {
  return (
    <div className='pt-48'>
      
      <div className='h-32  bg-[#242424]'>

      </div>

    </div>
  )
}
